import { Modal } from 'antd';
import { FC } from 'react';
import { CloseSvg, DeleteSvg } from 'utils/svgs';
import styles from './index.module.scss';
import { ConfirmDeleteProps } from './types';
import Buttons from '../Buttons';

// ConfirmDelete popup
const ConfirmDelete: FC<ConfirmDeleteProps> = (props) => {
	// Inits
	const {
		handleCancel,
		handleOk,
		isModalOpen,
		deleteHandler,
		isLoading,
		selectedDeleteData,
		deleteHeading
	} = props;
	const myButtons = [
		{
			text: 'Cancel',
			isLoading: false,
			className: 'secondary-button',
			fontSize: '1.8rem',
			minWidth: '14rem',
			minHeight: '4rem',
			isSubmit: false,
			onclick: () => {
				handleCancel();
			},
		},
		{
			text: 'Delete',
			isLoading: isLoading,
			className: 'remove-button',
			fontSize: '1.8rem',
			minWidth: '14rem',
			minHeight: '4rem',
			isSubmit: true,
			onclick: () => {
				deleteHandler();
			},
		},

	];
	//   JSX
	return (
		<Modal
			title={
				<>
					<div className={styles['confirm-delete-model']}>
						<DeleteSvg />
					</div>
					<p className={styles['confirm-delete-model__title']}>
						Do you really want to delete? {deleteHeading}! <p style={{fontSize:"14px", fontWeight:"400"}}>({selectedDeleteData})</p>
					</p>
					
				</>
			}
			open={isModalOpen}
			onOk={handleOk}
			onCancel={handleCancel}
			centered={true}
			width={380}
			closable={false}
			closeIcon={<CloseSvg />}
			footer={[
				<div
					key={'wrapper'}
					className={styles['confirm-delete-model__button']}
				>
					<Buttons buttons={myButtons}></Buttons>

				</div>
			]}
		></Modal>
	);
};

export default ConfirmDelete;
